import { useMemo } from 'react';
import { useRegistrySession } from '../session/RegistrySession';
import { useRegistry } from '../store/RegistryStore';
import type { EntitySource } from './entitySource';
import { createMockEntitySource } from './mockEntitySource';

/** The admin API when signed in; otherwise the mock platform entities in the prototype store. */
export function useEntitySource(): EntitySource {
  const session = useRegistrySession();
  const { state } = useRegistry();
  const entities = state.platformEntities;
  return useMemo(() => session?.api ?? createMockEntitySource(entities), [session, entities]);
}
